import React, { createContext } from 'react';

export const LangSwitchContext = createContext();
export function useLangSwitchContext() {
    return React.useContext(LangSwitchContext);
}

export const IsMobileContext = createContext();
export function useIsMobileContext() {
    return React.useContext(IsMobileContext);
}
export const IsDesktopOrLaptopContext = createContext();
export function useIsDesktopOrLaptopContext() {
    return React.useContext(IsDesktopOrLaptopContext);
}